export default "__VITE_ASSET__Dpzpqb9Y__"